import React from 'react';
/**
 * Spacer Component
 * @param size {SpacerSize} SMALL | MEDIUM | LARGE | HUGE
 * @param horizontal {Boolean} If horizontal margin
 */
const Spacer = ({ size, horizontal }) => {
    const styles = {
        spacer: {
            marginLeft: horizontal ? `${size}px` : '0px',
            marginTop: !horizontal ? `${size}px` : '0px',
        },
    };
    return React.createElement("div", { style: styles.spacer });
};
export default Spacer;
//# sourceMappingURL=Spacer.js.map